import { useEnsureAuthenticated } from "@/contexts/ensureAuthenticated";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import { userPermissions } from "@/contexts/userPermissions";
import { NewsLetterResponse, deleteNewsletter, getAllNewsletter as getAllNewsletterService } from "@/services/newsletter";
import { PermissionEnum } from "@/utils/permissionEnum";
import {
  ChevronDownIcon,
  ChevronUpIcon
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Link,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CiReceipt } from "react-icons/ci";
import { Link as RouterLink } from "react-router-dom";

export default function NewsletterListPage() {
  // const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // const [totalPage, setTotalPage] = useState(1);
  const { user } = useEnsureAuthenticated();
  const permissions = userPermissions(user);
  const toast = useToast();
  // const queryCache = useQueryClient()
  const backgroundStyle = useConditionalBackground();
  const [data, setData] = useState<NewsLetterResponse[]>()
  const [isLoading, setIsLoading] = useState(true);
  const [sortBy, setSortBy] = useState<"id" | "nome" | "descricao" | "status">("id");
  const [sortDirection, setSortDirection] = useState<"ASC" | "DESC">("ASC");



  const handleSort = async (field: "id" | "nome" | "descricao" | "status") => {
    setSortBy(field);
    setSortDirection(
      sortBy === field && sortDirection === "ASC" ? "DESC" : "ASC"
    );
  };

  // const { data } = useQuery<responseNewsLetter[]>({
  //   queryKey: ["newsletters"],
  //   queryFn: async () => await getAllNewsletterService(),
  //   staleTime: 100 * 1000,
  //   placeholderData: (prev) => prev,
  //   refetchOnWindowFocus: true,
  // });

  const handleDeleteNewsletter = async (id: string) => {
    try {
      await deleteNewsletter(id);
      setData((prev) => prev?.filter((item) => item.id !== id));
      toast({
        title: "Sucesso",
        description: "Conteúdo excluído com sucesso.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
   
    } catch (error) {
      console.error("Erro ao deletar newsletter:", error);
      throw error;
    }
  };
  const fetchAllNewsletters = async (): Promise<NewsLetterResponse[]> => {
    try {
      const response = await getAllNewsletterService();
      return response;
    }
    catch (error) {
      console.error("Erro ao buscar newsletters:", error);
      throw error;
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const newsletters = await fetchAllNewsletters();
        setData(newsletters);
      } catch (error) {
        console.error("Erro ao buscar newsletters:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();

  }, [])

  // const handleDeactivateCriteriaEngine = useMutation({
  //   mutationFn: async (data: { id: number, status: boolean }) => {
  //     await updateCriteriaEngine(data)
  //   },
  //   onSuccess(_, variables) {
  //     toast({
  //       title: "Sucesso",
  //       description: `Motor de crédito ${variables.status ? "ativado" : "desativado"} com successo`,
  //       status: "success",
  //       duration: 3000,
  //       isClosable: true,
  //     })

  //     const criteriaEngines = queryCache.getQueryData<CriteriaEngineResponse>(["criteria-engines", page, pageSize, sortBy, sortDirection])

  //     const updatedCriteriaEngine = criteriaEngines?.itens.map((item) => {
  //       return item.id === variables.id ? { ...item, status: variables.status } : item
  //     }
  //     );

  //     const criteriaEngineUpdated = {
  //       ...criteriaEngines,
  //       itens: updatedCriteriaEngine
  //     };

  //     queryCache.setQueryData(
  //       ["criteria-engines", page, pageSize, sortBy, sortDirection],
  //       criteriaEngineUpdated
  //     );
  //   },
  //   onError() {
  //     toast({
  //       title: "Erro",
  //       description: "Erro ao desativar motor de crédito",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // })

  return (
    <Box
      padding={{ base: "2", md: "4" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
    >
      <Box
        {...backgroundStyle}
        borderRadius="md"
        p={{ base: 4, md: 6 }}
        mb={4}
        color="white"
        boxShadow="md"
        width="100%"
      >
        <Flex
          alignItems={{ base: "center", md: "center" }}
          justifyContent="space-between"
          flexDirection={{ base: "column", md: "row" }}
          textAlign={{ base: "center", md: "left" }}
        >
          <Flex alignItems="center" mb={{ base: 4, md: 0 }}>
            <CiReceipt size="2rem" />
            <Text
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="bold"
              ml={4}
              fontFamily="Lexend Deca"
            >
              Newsletter
            </Text>
          </Flex>

          <Flex
            flexDirection={{ base: "column", md: "row" }}
            alignItems="flex-end"
            mt={{ base: 4, md: 0 }}
            width="100%"
            justifyContent={{ base: "center", md: "flex-end" }}
            gap={4}
          >
            {permissions.some(
              (permission) => permission === PermissionEnum.CREATE_USER
            ) && (
                <Stack
                  direction={{ base: "column", md: "row" }}
                  spacing={4}
                  width="100%"
                  justifyContent={{ base: "center", md: "end" }}
                >
                  <Link
                    as={RouterLink}
                    to="novo"
                    bg="white"
                    color="black"
                    px={4}
                    py={{ base: 4, md: 2 }}
                    borderRadius="md"
                    fontWeight="bold"
                    _hover={{ bg: "gray.200" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontSize={{ base: "lg", md: "md" }}
                    height={{ base: "56px", md: "40px" }}
                    width={{ base: "100%", md: "auto" }}
                    fontFamily="Lexend Deca"
                  >
                    <CiReceipt style={{ marginRight: "8px", fontSize: "20px" }} />
                    Cadastrar Conteúdo
                  </Link>
                </Stack>
              )}
          </Flex>
        </Flex>
        {/* <Flex w="30%" mt={8} gap={2}>
          <InputGroup>
            <InputLeftElement mt={1} pointerEvents="none">
              <CiSearch color="black" size="2rem" />
            </InputLeftElement>
            <Input
              height={{ base: "56px", md: "48px" }}
              bg={"white"}
              placeholder="Pesquisar..."
              variant="filled"
              type="text"
              maxLength={30}
              color="black"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              _focus={{ bg: "white" }}
              _hover={{ bg: "white" }}
              fontFamily="Lexend Deca"
            />
          </InputGroup>
        </Flex> */}
      </Box>
      <Flex
        justify="center"
        alignItems="center"
        mb={4}
        flexDirection={{ base: "column", md: "row" }}
        width="100%"
        maxWidth="1200px"
        px={{ base: 2, md: 0 }}
      >
        {/* <Flex alignItems="center" mb={{ base: 2, md: 0 }}>
          <IconButton
            icon={<ChevronLeftIcon />}
            onClick={() => setPage(data?.pagina_anterior)}
            isDisabled={page === 1}
            mr={2}
            aria-label="Previous Page"
            size={{ base: "md", md: "sm" }}
          />
          <Text fontSize={{ base: "lg", md: "md" }} fontFamily="Lexend Deca">
            Página {data?.pagina_atual || page} de {totalPage}
          </Text>
          <IconButton
            icon={<ChevronRightIcon />}
            onClick={() => setPage(data?.proxima_pagina)}
            isDisabled={data?.pagina_atual === data?.total_paginas}
            ml={2}
            aria-label="Next Page"
            size={{ base: "md", md: "sm" }}
          />
        </Flex> */}
        <Box ml={{ base: 0, md: 4 }} mt={{ base: 2, md: 0 }}>
          <Select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              // setPage(1);
            }}
            width={{ base: "100%", md: "auto" }}
            size={{ base: "md", md: "sm" }}
            fontSize={{ base: "lg", md: "md" }}
            fontFamily="Lexend Deca"
          >
            <option value={10}>10 por página</option>
            <option value={20}>20 por página</option>
            <option value={50}>50 por página</option>
            <option value={100}>100 por página</option>
          </Select>
        </Box>
      </Flex>

      {isLoading ? (
        <Box width="100%" textAlign="center" mt={8}>
          <Text fontFamily="Lexend Deca">Carregando newsletters...</Text>
        </Box>
      ) : (
      <Box width="100%" overflow="visible" >
        <TableContainer borderRadius="md" boxShadow="md" >
          <Table size="sm" w='100%'>
            <Thead
              {...backgroundStyle}
              position="sticky"
              top={0}
              zIndex={1}
              boxShadow="md"
            >
              <Tr>
                <Th color={'white'} textAlign="center" fontSize="xs" py={5}>
                  <HStack justify="center">
                    <Text>AÇÕES</Text>
                  </HStack>
                </Th>
                <Th color={'white'} textAlign="center" fontSize="xs" py={5}>
                  <HStack justify="center">
                    <Text>Id</Text>
                    <IconButton
                      icon={
                        sortBy === "id" && sortDirection === "ASC" ? (
                          <ChevronUpIcon />
                        ) : (
                          <ChevronDownIcon />
                        )
                      }
                      variant="ghost"
                      size="1"
                      fontSize={"1rem"}
                      borderRadius={"lg"}
                      aria-label="Sort by Id"
                      bg={"gray.200"}
                      onClick={() => handleSort("id")}
                    />
                  </HStack>
                </Th>
                <Th color={'white'} textAlign="center" fontSize="xs" py={5}>
                  <HStack justify="center">
                    <Text>Title</Text>
                    <IconButton
                      icon={
                        sortBy === "nome" && sortDirection === "ASC" ? (
                          <ChevronUpIcon />
                        ) : (
                          <ChevronDownIcon />
                        )
                      }
                      variant="ghost"
                      size="1"
                      fontSize={"1rem"}
                      borderRadius={"lg"}
                      aria-label="Sort by Name"
                      bg={"gray.200"}
                      onClick={() => handleSort("nome")}
                    />
                  </HStack>
                </Th>

                <Th color={'white'} textAlign="center" fontSize="xs" py={5}>
                  <HStack justify="center">
                    <Text>Conteúdo</Text>
                    <IconButton
                      icon={
                        sortBy === "descricao" && sortDirection === "ASC" ? (
                          <ChevronUpIcon />
                        ) : (
                          <ChevronDownIcon />
                        )
                      }
                      variant="ghost"
                      size="1"
                      fontSize={"1rem"}
                      borderRadius={"lg"}
                      aria-label="Sort by Percentage"
                      bg={"gray.200"}
                      onClick={() => handleSort("descricao")}
                    />
                  </HStack>
                </Th>

                <Th color={'white'} textAlign="center" fontSize="xs" py={5}>
                  <HStack justify="center">
                    <Text>Type</Text>
                    <IconButton
                      icon={
                        sortBy === "status" && sortDirection === "ASC" ? (
                          <ChevronUpIcon />
                        ) : (
                          <ChevronDownIcon />
                        )
                      }
                      variant="ghost"
                      size="1"
                      fontSize={"1rem"}
                      borderRadius={"lg"}
                      aria-label="Sort by enabled"
                      bg={"gray.200"}
                      onClick={() => handleSort("status")}
                    />
                  </HStack>
                </Th>
              </Tr>
            </Thead>
            <Tbody>

              {data?.map((newsletter) => (
                <Tr
                  key={newsletter.id}
                  transition="all 0.3s ease-in-out"
                  borderBottom="1px solid"
                  fontFamily="Lexend Deca"

                >
                  <Td
                    textAlign="center"
                    fontSize={{ base: "lg", md: "sm" }}
                    py={{ base: 2, md: 3 }}
                    fontFamily="Lexend Deca"
                    width={"250px"}
                  >
                    <Flex justify="center" flexDirection="column" gap={2}>
                      {(
                        <Button
                          size={{ base: "md", md: "md" }}
                          colorScheme="red"
                          onClick={() => handleDeleteNewsletter(newsletter.id)}
                          width="100%"
                          py={{ base: 2.5, md: 2 }}
                          fontSize={{ base: "md", md: "sm" }}
                          fontWeight="bold"
                          fontFamily="Lexend Deca"
                        >
                          Excluir Conteúdo
                        </Button>)

                        // ) : (
                        //   <Button
                        //     size={{ base: "md", md: "md" }}
                        //     colorScheme="green"
                        //     onClick={() => handleDeactivateCriteriaEngine.mutate({id: criteriaEngine.id, status: !criteriaEngine.status})}
                        //     width="100%"
                        //     py={{ base: 2.5, md: 2 }}
                        //     fontSize={{ base: "md", md: "sm" }}
                        //     fontWeight="bold"
                        //     fontFamily="Lexend Deca"
                        //   >
                        //     Ativar Critério
                        //   </Button>
                        // )}
                      }
                    </Flex>
                  </Td>

                  <Td textAlign="center" fontSize="sm" py={{ base: 2, md: 3 }}>
                    <Link
                      as={RouterLink}
                      to={`/newsletter/${newsletter.id}`}
                      color="blue.500"
                    >
                      {newsletter.id}
                    </Link>
                  </Td>

                  <Td textAlign="center" fontSize="sm" py={{ base: 2, md: 3 }}>
                    <Text whiteSpace="normal" wordBreak="break-word">
                      {newsletter.title}
                      {/* colocar title */}
                    </Text>
                  </Td>

                  <Td textAlign="center" fontSize="sm" py={{ base: 2, md: 3 }} >
                    <Box whiteSpace="pre-wrap" wordBreak="break-word" textAlign="left">
                      {newsletter.content}
                    </Box>
                    {/* colocar conteudo */}
                  </Td>

                  <Td textAlign="center" fontSize="sm" py={{ base: 2, md: 3 }}>
                    {newsletter.type}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      )}

      <Flex
        justify="center"
        alignItems="center"
        flexDirection={{ base: "column", md: "row" }}
        width="100%"
        maxWidth="1200px"
        px={{ base: 2, md: 0 }}
      >
        {/* <Flex alignItems="center" mt={4} mb={{ base: 2, md: 2 }}>
          <IconButton
            icon={<ChevronLeftIcon />}
            onClick={() => setPage(data?.pagina_anterior)}
            isDisabled={page === 1}
            mr={2}
            aria-label="Previous Page"
            size={{ base: "md", md: "sm" }}
          />
          <Text fontSize={{ base: "lg", md: "md" }} fontFamily="Lexend Deca">
            Página {data?.pagina_atual} de {totalPage}
          </Text>
          <IconButton
            icon={<ChevronRightIcon />}
            onClick={() => setPage(data?.proxima_pagina)}
            isDisabled={data?.pagina_atual === data?.total_paginas}
            ml={2}
            aria-label="Next Page"
            size={{ base: "md", md: "sm" }}
          />
        </Flex> */}
        <Box ml={{ base: 0, md: 4 }} mb={2} mt={{ base: 2, md: 4 }}>
          <Select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              // setPage(1);
            }}
            width={{ base: "100%", md: "auto" }}
            size={{ base: "md", md: "sm" }}
            fontSize={{ base: "lg", md: "md" }}
            fontFamily="Lexend Deca"
          >
            <option value={10}>10 por página</option>
            <option value={20}>20 por página</option>
            <option value={50}>50 por página</option>
            <option value={100}>100 por página</option>
          </Select>
        </Box>
      </Flex>
    </Box>
  );
}
